import React from 'react';
import { Button } from './ui/button';
import { useCurrencies, useSelectedCurrency } from '../context/CurrencyContext';
import { currencySymbol } from '../lib/constants';

export const useStaffCurrency = useSelectedCurrency;
export const CurrencySwitcher = ({ currency, onChange, disabled = false }) => {
  const { codes } = useCurrencies();
  return <div role="group" aria-label="Displayed currency" className="inline-flex flex-wrap max-w-full gap-1 border border-slate-200 rounded-md bg-white p-1 print:hidden" data-testid="staff-currency-switcher">
    {codes.map(c => <Button type="button" key={c} data-testid={`staff-currency-${c.toLowerCase()}`} aria-pressed={currency === c} disabled={disabled} size="sm" variant={currency === c ? 'default' : 'ghost'} className={currency === c ? 'bg-emerald-700 hover:bg-emerald-800 text-white min-w-16' : 'min-w-16 text-slate-600'} onClick={() => onChange(c)}>{currencySymbol(c)} {c}</Button>)}
  </div>;
};